import { render, staticRenderFns } from "./add-product.vue?vue&type=template&id=6bd9caa1&scoped=true&"
import script from "./add-product.vue?vue&type=script&lang=js&"
export * from "./add-product.vue?vue&type=script&lang=js&"
import style0 from "./add-product.vue?vue&type=style&index=0&id=6bd9caa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9caa1",
  null
  
)

export default component.exports